import { useRef, useMemo } from 'react';
import * as THREE from 'three';
import { COLOR_CONFIG, FLOOR_MATERIAL_CONFIG } from '../config/colorConfig';
import { DEFAULT_TRANSPARENCY, HOVERED_TRANSPARENCY } from '../config/sceneConfig';

/**
 * Custom hook to manage scene materials
 * @param {string} primaryColor - Primary color for materials
 * @param {number} [transparency] - Optional transparency override
 * @returns {Object} Material references
 */
export const useSceneMaterials = (primaryColor, transparency) => {
  const vacantColor = useRef();
  const occupiedColor = useRef();
  const vacantHoveredColor = useRef();
  const occupiedHoveredColor = useRef();
  const floorMat = useRef(new THREE.MeshStandardMaterial(FLOOR_MATERIAL_CONFIG));

  // Initialize materials
  useMemo(() => {
    const opacity = transparency ?? DEFAULT_TRANSPARENCY;

    vacantColor.current = new THREE.MeshBasicMaterial({
      color: primaryColor,
      transparent: true,
      opacity: opacity,
    });

    occupiedColor.current = new THREE.MeshBasicMaterial({
      color: COLOR_CONFIG.OCCUPIED_COLOR,
      transparent: true,
      opacity: opacity,
    });

    vacantHoveredColor.current = new THREE.MeshBasicMaterial({
      color: primaryColor,
      transparent: true,
      opacity: HOVERED_TRANSPARENCY,
    });

    occupiedHoveredColor.current = new THREE.MeshBasicMaterial({
      color: COLOR_CONFIG.OCCUPIED_COLOR_STRING,
      transparent: true,
      opacity: HOVERED_TRANSPARENCY,
    });
  }, [primaryColor, transparency]);

  return {
    vacantColor,
    occupiedColor,
    vacantHoveredColor,
    occupiedHoveredColor,
    floorMat,
  };
};
